/* Wheel of the year for the 24 solar breaths: a 24-segment ring tinted by Wu
   Xing phase, current breath pulled outward, hub previewing the hovered one,
   click scrolling to its entry. Hidden without JS; geometry computed here,
   Liquid having no trigonometry. */
(function () {
  var bq = window.bq;
  if (!bq) return;

  var SVGNS = 'http://www.w3.org/2000/svg';
  var CX = 210, CY = 210;
  var R_OUT = 190, R_IN = 150, R_NOW = 202; // ring radii + current-breath tip
  var GAP = 2.2; // gap in degrees between segments
  var STEP = 360 / 24;

  function polar(r, deg) {
    var a = (deg * Math.PI) / 180;
    return [CX + r * Math.sin(a), CY - r * Math.cos(a)];
  }

  // Ring (donut) segment from angle a0 to a1.
  function donutPath(a0, a1, rOut, rIn) {
    var p1 = polar(rOut, a0), p2 = polar(rOut, a1);
    var p3 = polar(rIn, a1), p4 = polar(rIn, a0);
    var large = a1 - a0 > 180 ? 1 : 0;
    return (
      'M' + p1[0].toFixed(2) + ' ' + p1[1].toFixed(2) +
      'A' + rOut + ' ' + rOut + ' 0 ' + large + ' 1 ' + p2[0].toFixed(2) + ' ' + p2[1].toFixed(2) +
      'L' + p3[0].toFixed(2) + ' ' + p3[1].toFixed(2) +
      'A' + rIn + ' ' + rIn + ' 0 ' + large + ' 0 ' + p4[0].toFixed(2) + ' ' + p4[1].toFixed(2) +
      'Z'
    );
  }

  function el(name, attrs) {
    var n = document.createElementNS(SVGNS, name);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    return n;
  }

  function build(root) {
    if (!root || root.dataset.bqWheelInit) return;
    root.dataset.bqWheelInit = '1';
    var dataEl = root.querySelector('[data-bq-wheel-data]');
    if (!dataEl) return;
    var items;
    try { items = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!items || !items.length) return;

    // Localized labels ride on the root's data attributes (assets cannot
    // reach the locale files); French stays as the safety net.
    var L = {
      cue: root.dataset.labelCue || 'Voir le détail',
      wheel: root.dataset.labelWheel || 'Roue des 24 souffles de l’année',
      now: root.dataset.labelNow || 'en ce moment',
    };

    var nowIdx = 0;
    for (var i = 0; i < items.length; i++) if (items[i].now) nowIdx = i;

    var svg = el('svg', {
      viewBox: '0 0 420 420',
      class: 'bq-cal__wheel-svg',
      role: 'img',
      'aria-label': L.wheel
    });

    // Season thread: 4 subtle arcs behind the ring (6 breaths per season).
    var seasons = ['Printemps', 'Été', 'Automne', 'Hiver'];
    for (var s = 0; s < 4; s++) {
      var sa0 = s * 90 + 2, sa1 = s * 90 + 88;
      svg.appendChild(el('path', {
        d: donutPath(sa0, sa1, R_IN - 6, R_IN - 9),
        fill: 'none',
        stroke: 'var(--bq-wheel-season, rgba(120,110,90,.28))',
        'stroke-width': '1'
      }));
    }

    var segs = [];
    items.forEach(function (it, idx) {
      var isNow = idx === nowIdx;
      var a0 = idx * STEP + GAP / 2;
      var a1 = (idx + 1) * STEP - GAP / 2;
      var seg = el('path', {
        d: donutPath(a0, a1, isNow ? R_NOW : R_OUT, R_IN),
        fill: it.color,
        class: 'bq-cal__wheel-seg' + (isNow ? ' is-now' : ''),
        role: 'button',
        tabindex: '0',
        'aria-label': it.nom + ', ' + it.dates + (isNow ? ' (' + L.now + ')' : '')
      });
      seg.dataset.idx = idx;
      seg.dataset.anchor = it.anchor;
      segs.push(seg);
      svg.appendChild(seg);
    });

    root.appendChild(svg);

    // HTML hub (fonts + hanzi) overlaid at the center.
    var hub = document.createElement('div');
    hub.className = 'bq-cal__wheel-hub';
    hub.innerHTML =
      '<span class="bq-cal__wheel-hz" lang="zh" aria-hidden="true"></span>' +
      '<span class="bq-cal__wheel-nom"></span>' +
      '<span class="bq-cal__wheel-dates"></span>' +
      '<span class="bq-cal__wheel-cue"></span>';
    root.appendChild(hub);

    var hz = hub.querySelector('.bq-cal__wheel-hz');
    var nom = hub.querySelector('.bq-cal__wheel-nom');
    var dates = hub.querySelector('.bq-cal__wheel-dates');
    hub.querySelector('.bq-cal__wheel-cue').textContent = L.cue + ' ↓';

    function showHub(idx) {
      var it = items[idx];
      hz.textContent = it.hz;
      hz.style.color = it.color;
      nom.textContent = it.nom;
      dates.textContent = it.dates;
      hub.dataset.anchor = it.anchor;
    }
    showHub(nowIdx);

    // Hover/focus: hub previews the pointed breath; leaving restores the current one.
    function preview(idx) { showHub(idx); }
    function restore() { showHub(nowIdx); }

    function goTo(anchor) {
      var target = document.getElementById(anchor);
      if (!target) return;
      target.scrollIntoView({ block: 'center', behavior: bq.reducedMotion() ? 'auto' : 'smooth' });
      target.classList.add('bq-cal__item--flash');
      setTimeout(function () { target.classList.remove('bq-cal__item--flash'); }, 1400);
    }

    segs.forEach(function (seg) {
      var idx = +seg.dataset.idx;
      seg.addEventListener('mouseenter', function () { preview(idx); });
      seg.addEventListener('focus', function () { preview(idx); });
      seg.addEventListener('mouseleave', restore);
      seg.addEventListener('blur', restore);
      seg.addEventListener('click', function () { goTo(seg.dataset.anchor); });
      seg.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); goTo(seg.dataset.anchor); }
      });
    });

    // The hub (current breath) is clickable too.
    hub.addEventListener('click', function () {
      if (hub.dataset.anchor) goTo(hub.dataset.anchor);
    });

    root.hidden = false;
    root.classList.add('is-ready');
  }

  function init() {
    document.querySelectorAll('[data-bq-wheel]').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-bq-wheel]').forEach(build);
  });
})();
